import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import LoadingDots from "../../extras/LoadingDots";
import IntervalDataRow from "../IntervalDataComponents/IntervalDataRow";
import { IonButton, IonIcon, IonRow } from "@ionic/react";
import { createOutline } from "ionicons/icons";
import { isStaff } from "../../extras/Functions";
import { useSelector } from "react-redux";
import { selectUser } from "../../../reducers/UserReducer";
import EditIntervalDataBaselineDateModal from "../Modals/EditIntervalDataBaselineDateModal";

interface IProps {
    id:string,
    cols:number,
    baseline_date:String|null|undefined
};

async function getIntervalData(token: string,id:string,type:string) {
  return fetch(`${API_URL}/graphs/interval_data/${id}/${type}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    }
  }).then((res) => 
    res.json())
}

const IntervalData:FC<IProps> = (props) => {
    const user = useSelector(selectUser)
    const [hourly,setHourly] = useState<any>(null)
    const [daily,setDaily] = useState<any>(null)
    const [weekly,setWeekly] = useState<any>(null)
    const [loading,setLoading] = useState(true)
    const [baselineDateModal, setBaselineDateModal] = useState(false)
    const [data, setData] = useState({"baseline_date":props.baseline_date})
    const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

    useEffect(()=>{
        const handleData = async (type:string) => {
            const token = `Token ${(localStorage.getItem("token")||'').slice(1, -1)}`;
            const res = await getIntervalData(token,props.id,type)
            
            if(res.status === 'success'){
                switch (type){
                    case 'hourly':
                        setHourly(res.data)                                              
                        break;
                    case 'daily':
                        setDaily(res.data)
                        break;
                    case 'weekly':
                        setWeekly(res.data)
                        break;
                    default:
                        console.log("Wrong request type.")
                }                
            }
           
        };
        handleData('hourly')
        handleData('daily')
        handleData('weekly')        
      
    },[props.id])

    useEffect(()=>{
        if(hourly && daily && weekly){
            setLoading(false)
        }}, [hourly,daily,weekly])
    

    return <div>
        <div style={{width:'100%', textAlign:'center'}}>
            <IonRow className="ion-justify-content-center ion-align-items-center">
                <h2 className={newUI ? 'text-dark-blue':''}>Interval Data Baseline End Date</h2>
                <IonButton
                    hidden={!isStaff(user)}
                    id="edit-building"
                    fill="clear"
                    color={newUI ? "dark" :"light"}
                    size="small"
                    // slot="icon-only"
                    // className="testing"
                    onClick={()=>setBaselineDateModal(true)}
                >
                    <IonIcon slot="icon-only" src={createOutline}></IonIcon>
                </IonButton>
            </IonRow>
            <div>{data.baseline_date?.toLocaleString()}</div>
        </div>
        <EditIntervalDataBaselineDateModal opened={baselineDateModal} setOpened={setBaselineDateModal} date={props.baseline_date} id={props.id} setData={setData}/>
        {loading ? <LoadingDots /> : 
            Object.entries(hourly).map((([key, value]:any)=>{                
                return <div key={key} style={{border:'white solid 2px', borderRadius:'2rem', marginBottom:'1rem', marginTop:'1rem', padding:'1rem'}}>
                    <h3 className={newUI ? 'text-dark-blue':''}  style={{textAlign:'center', marginBottom:'0'}}> {value.meter_name}</h3>
                    <h5 style={{textAlign:'center', marginTop:'0'}}> ({value.units})</h5>
                    <IntervalDataRow hourly={value} daily={daily[key]} weekly={weekly[key]} cols={props.cols} units={value.units}/>
                </div>
            }))
    }
    </div>
};

export default IntervalData;